const styleDate = (dateString, style = "long") => {
  if (!dateString || dateString === "") return null;

  return new window.Date(dateString).toLocaleString("fr",  { hour12: false });
};

export default styleDate;
